var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bookshelves"},_vm._l((_vm.shelfs),function(books,i){return _c('bookshelf',{key:i,attrs:{"books":books,"max":_vm.shelfColumn},on:{"read":function($event){_vm.$emit('read', $event)}}})}))}
var staticRenderFns = []

export { render, staticRenderFns }